import React, { useState, useEffect } from 'react'

import ApplyV2Button from '@core/components/ApplyDialogV2/ApplyV2Button'
import ApplyV2NoFieldsSwitch from '@core/components/ApplyDialogV2/ApplyV2NoFieldsSwitch'
import useApplyV2NavTranslations from '@core/utils/hooks/useApplyV2NavTranslations'
import './ApplyV2DriverLicenseStep.scss'
import { useApplyV2Context } from '@core/utils/contexts/ApplyV2ModalContext/ApplyV2ModalContext'
import { usePostLicenseV2ApplyMutation } from '@core/app/api/applyJobV2Api'

import a from '@page/profile/assets/images/license/a.svg'
import a1 from '@page/profile/assets/images/license/a1.svg'
import b from '@page/profile/assets/images/license/b.svg'
import be from '@page/profile/assets/images/license/be.svg'
import c from '@page/profile/assets/images/license/c.svg'
import c1 from '@page/profile/assets/images/license/c1.svg'
import c1e from '@page/profile/assets/images/license/c1e.svg'
import ce from '@page/profile/assets/images/license/ce.svg'
import d from '@page/profile/assets/images/license/d.svg'
import d1 from '@page/profile/assets/images/license/d1.svg'
import d1e from '@page/profile/assets/images/license/d1e.svg'
import de from '@page/profile/assets/images/license/de.svg'
import forklift from '@page/profile/assets/images/license/forklift.svg'
import m from '@page/profile/assets/images/license/m.svg'
import s from '@page/profile/assets/images/license/s.svg'
import tt from '@page/profile/assets/images/license/t.svg'

import { MainIcon } from './icons/icon'

import { useTranslation } from 'react-i18next'

const licenseTypes = [
    { id: 1, name: 'A1', icon: a1 },
    { id: 5, name: 'A', icon: a },
    { id: 8, name: 'B', icon: b },
    { id: 17, name: 'B (auto)', icon: b },
    { id: 9, name: 'BE', icon: be },
    { id: 11, name: 'C1', icon: c1 },
    { id: 12, name: 'C1E', icon: c1e },
    { id: 14, name: 'C', icon: c },
    { id: 15, name: 'CE', icon: ce },
    { id: 2, name: 'D1', icon: d1 },
    { id: 3, name: 'D1E', icon: d1e },
    { id: 6, name: 'D', icon: d },
    { id: 7, name: 'DE', icon: de },
    { id: 10, name: 'M', icon: m },
    { id: 13, name: 'S', icon: s },
    { id: 4, name: 'T', icon: tt },
    { id: 16, name: 'Forklift', icon: forklift },
]

const baseClass = 'DriverLicenseStep'

const DriverLicenseStep: React.FC = () => {
    const { t } = useTranslation()
    const { getTitle } = useApplyV2NavTranslations()
    const { postProfileData, onNextStep, settingsData } = useApplyV2Context()
    const uid = postProfileData?.data?.uid ?? ''
    const [postLicense] = usePostLicenseV2ApplyMutation()
    const [noDriverLicense, setNoDriverLicense] = useState(false)

    const [state, setState] = useState<'empty' | 'list'>(
        (postProfileData?.data?.driverLicence?.length ?? 0) === 0 ? 'empty' : 'list'
    )

    const [selected, setSelected] = useState<number[]>([])

    useEffect(() => {
        const initial = postProfileData?.data?.driverLicence ?? []

        if (initial.includes(66)) {
            setNoDriverLicense(true)
            setSelected([66])
            setState('empty')
        } else {
            setSelected(initial.filter((i) => i !== 66))
        }
    }, [postProfileData?.data?.driverLicence])

    const toggleLicense = async (id: number) => {
        const selectedSet = new Set(selected)

        if (selectedSet.has(id)) {
            selectedSet.delete(id)
        } else {
            selectedSet.add(id)
            selectedSet.delete(66)
        }

        const newSelected = Array.from(selectedSet)
        setSelected(newSelected)

        try {
            await postLicense({ uid, body: { ids: newSelected } }).unwrap()
        } catch (err) {
            console.error('Failed to save driver licenses:', err)
        }
    }

    const handleAddClick = () => {
        setState('list')
    }

    return (
        <div className="DriverLicenseStep">
            {state === 'empty' && (
                <>
                    <div className={`${baseClass}__edu-empty ${baseClass}__empty`}>
                        <div className={`${baseClass}__edu-empty-icon ${baseClass}__empty--icon`}>
                            <MainIcon />
                        </div>
                        <div className={`${baseClass}__edu-empty-content ${baseClass}__empty--content`}>
                            <div className={`${baseClass}__edu-empty-title ${baseClass}__empty--content-title`}>
                                {noDriverLicense
                                    ? (t('10307', "I don't have a driver's license") as string)
                                    : (t('10297', 'No driver license added yet') as string)}
                            </div>
                            <div className={`${baseClass}__edu-empty-actions ${baseClass}__empty--content-actions`}>
                                <button
                                    className={`${baseClass}__edu-empty__add-edu-btn`}
                                    type="button"
                                    disabled={noDriverLicense}
                                    onClick={handleAddClick}
                                >
                                    + {t('3299', 'Add driver license') as string}
                                </button>
                                {/*<div className="no-edu-toggle" onClick={() => setNoDriverLicense((v) => !v)}>*/}
                                {/*    <div className={`toggle-switch${noDriverLicense ? ' checked' : ''}`}>*/}
                                {/*        <div className="toggle-thumb" />*/}
                                {/*    </div>*/}
                                {/*    <span>{t('10298', 'No license') as string}</span>*/}
                                {/*</div>*/}
                                <ApplyV2NoFieldsSwitch
                                    className={`${baseClass}__empty--desc-switch`}
                                    checked={noDriverLicense}
                                    onChange={setNoDriverLicense}
                                    label={getTitle('10298', 'No license')}
                                />
                            </div>
                        </div>
                    </div>
                    {/*<div className="row right">*/}
                    {/*    <button type="button" disabled={!noDriverLicense} className="next-btn" onClick={onNextStep}>*/}
                    {/*        {t('3035', 'Next')}*/}
                    {/*    </button>*/}
                    {/*</div>*/}
                    <div className={`ApplyDialogV2__next ${baseClass}__next`}>
                        {!settingsData?.steps?.driverLicence?.required && (
                            <ApplyV2Button
                                variant={'transparent'}
                                className={`ApplyDialogV2__next--btn ApplyDialogV2__next--btn-skip`}
                                rightIcon={'>'}
                                // isDisabled={!isValid || isLoading}
                                onClick={() => {
                                    onNextStep()
                                }}
                            >
                                {getTitle('6107', 'Skip')}
                            </ApplyV2Button>
                        )}
                        <ApplyV2Button
                            type="submit"
                            variant={'primary'}
                            className={`ApplyDialogV2__next--btn ApplyDialogV2__next--btn-submit`}
                            // isLoading={isLoading}
                            isDisabled={!noDriverLicense}
                            onClick={onNextStep}
                        >
                            {getTitle('3035', 'Next')}
                        </ApplyV2Button>
                    </div>
                </>
            )}

            {state === 'list' && (
                <>
                    <div className="license-grid">
                        {licenseTypes.map((license) => (
                            <div
                                key={license.id}
                                className={`license-item${selected.includes(license.id) ? ' selected' : ''}`}
                                onClick={() => toggleLicense(license.id)}
                            >
                                <input
                                    type="checkbox"
                                    checked={selected.includes(license.id)}
                                    onChange={() => toggleLicense(license.id)}
                                />
                                <div className="license-icon">
                                    <img src={license.icon} alt={license.name} />
                                </div>
                                <div className="license-name">{license.name}</div>
                            </div>
                        ))}
                    </div>
                    <div className={`row ${state === 'list' ? 'center' : 'right'}`}>
                        {state === 'list' && (
                            <button
                                type="button"
                                className="cancel-btn cancel-btn-hover"
                                onClick={() => setState('empty')}
                            >
                                {t('416', 'Cancel')}
                            </button>
                        )}

                        <button
                            type="button"
                            className="next-btn"
                            disabled={selected.length === 0 && !noDriverLicense}
                            onClick={onNextStep}
                        >
                            {t('3035', 'Next')}
                        </button>
                    </div>
                </>
            )}
        </div>
    )
}

export default DriverLicenseStep
